export enum FooterSocialSite {
  FACEBOOK = 'facebook',
  PINTEREST = 'pinterest',
  INSTAGRAM = 'instagram',
  TWITTER = 'twitter',
  LINKEDIN = 'linkedin',
  YOUTUBE = 'youtube',
}

export enum FooterColumnType {
  LINKS = 'links',
  SOCIAL = 'social',
}

export interface IFooterFullLink {
  href: string;
  text: string;
}

export interface IFooterSocialLink {
  name: string;
  site: FooterSocialSite;
}

export type IFooterLink = IFooterFullLink | IFooterSocialLink;

interface IFooterColumnBase<T extends FooterColumnType> {
  type: T;
  title: string;
}

export interface IFooterColumn
  extends IFooterColumnBase<FooterColumnType.LINKS> {
  links: ReadonlyArray<IFooterFullLink>;
}

export interface IFooterSocialColumn
  extends IFooterColumnBase<FooterColumnType.SOCIAL> {
  links: ReadonlyArray<IFooterSocialLink>;
}

export interface IFooter {
  columns: ReadonlyArray<IFooterColumn | IFooterSocialColumn>;
}
